import "babel-polyfill";
import React from "react";
import { Provider } from "react-redux";
import { store } from "./store.js";
import { router } from "./router.js";

// render the main component
const provider = (
  <Provider store={store}>
    {router}
  </Provider>);

export { provider };


// WEBPACK FOOTER //
// ./src/startup/provider.js